module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/logo_leaders02-da0b34166dc46f29bd55a69338ac5798.svg";